module.exports = __webpack_public_path__ + "static/dp-kollage-teaser-928b3cee8975fd780a1e4b557b7c2635.jpg";